import {segment} from './helpers'

export const dashboardClosed = () => segment('Dashboard Closed')
export const dashboardOpened = () => segment('Dashboard Opened')
export const dashboardLinkClicked = ({targetLinkUrl, targetLinkName, isMediumTabletOrLarger}) => {
  const traits = {targetLinkUrl, targetLinkName}
  if (isMediumTabletOrLarger) {
    traits.getPlaform = 'tablet/desktop'
  }
  segment('Clicked Dashboard Link', traits)
}

export const dashboardEventDetailChanged = (detail, type) =>
  segment(`Dashboard Event ${type} Changed`, detail)

export const dashboardEventNumMembersChanged = (numParticipants) =>
  segment('Dashboard Event Participants Changed', {
    numParticipants,
  })

export const dashboardEventOwnerRoleChanged = (role) =>
  segment('Dashboard Event Role Changed', {role})

export const dashboardContinueClicked = (data) => segment('Dashboard Continue Clicked', data)

// Dashboard errors
const combineErrors = (errors) => {
  const errorList = []
  if (errors.emptyHtos.length) errorList.push('Empty HTO')
  if (errors.noHtoDate) errorList.push('No HTO Date')
  if (errors.emptyLooks.length) errorList.push('Empty Look')
  if (errors.unassignedLooks.length) errorList.push('Unassigned Look')

  return errorList
}

export const dashboardErrorBlockedCustomer = (date, errors) => {
  const errorList = combineErrors(errors)
  segment('Dashboard Blocking Error', {date, errorList})
}

export const dashboardBannerDisplayed = () => {
  segment('Displayed Dashboard Banner')
}
